import React from 'react';
import clsx from 'clsx';

import './index.scss';

const SpSuggestList = ({ items = [], onClick, fullWidth = false }) => (
  <div className={clsx(
    'SpSuggestList',
    { many: items.length > 5 },
    { nolist: items.length === 0 },
    { fullWidth },
  )}
  >
    <ul className="list-wrapper">
      {items.map((item, key) => {
        return (
          <li className="list" key={item} id="spSuggestItem">
            <button
              className="button"
              type="button"
              tabIndex="0"
              onClick={() => onClick(key)}
            >
              {item}
            </button>
          </li>
        );
      })}
    </ul>
  </div>
);

export default SpSuggestList;